import { render } from "./AdminComponent.vue?vue&type=template&id=27c84526"
import script from "./AdminComponent.vue?vue&type=script&lang=js"
export * from "./AdminComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hooeni/Workspace/nodebee_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__